/*
 *** NOTE : PleasE do not modify or check-in this file
 */
module.exports = {
  DOMAIN_NAME_PROD: 'https://service.icicibank.com/',
  DOMAIN_NAME_PRE_PROD: 'http://35.200.156.122:5000/',
  DOMAIN_NAME_STAG: 'https://csrstaging.niveussolutions.com/',
  DOMAIN_NAME_DEV: 'https://csr.niveussolutions.com/',
  DOMAIN_NAME_OVERDUE: 'https://csroverdue.niveussolutions.com',
  DOMAIN_NAME_UAT:'https://service-uat.icicibank.com'
};
/*
 *** NOTE : Please do not modify or check-in this file
 */
